import React from 'react'
import { Spinner } from 'react-bootstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import Select from 'react-select'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import './TagGeneratedQuestionsModal.css'

const MODES = {
  CLONE: 'CLONE',
  CONNECT_EXISTING: 'CONNECT_EXISTING',
}

const TagGeneratedQuestionsModal = ({
  isOpen,
  toggle,
  reports,
  mode,
  onModeChange,
  selectedReportId,
  onSelectedReportChange,
  options,
  onOptionsChange,
  onSubmit,
  submitting,
  connectedReport,
  tooltipPrefix = 'llm-visibility-tagging',
}) => {
  const reportOptions = reports.map((report) => ({
    value: report.id,
    label: `${report.name}${report.status ? ` (${report.status})` : ''}`,
  }))

  const selectedOption = reportOptions.find((option) => option.value === selectedReportId) || null

  const updateOption = (key) => (event) => {
    onOptionsChange({
      ...options,
      [key]: event.target.checked,
    })
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Tagga domande generate</ModalHeader>
      <ModalBody className="tag-generated-questions-modal">
        {connectedReport && (
          <div className="tag-generated-questions-modal__current">
            <small className="text-muted d-block">Connessione attuale</small>
            <strong>{connectedReport.name}</strong>
            {connectedReport.status && <span className="ml-2 text-muted">({connectedReport.status})</span>}
          </div>
        )}

        <div className="tag-generated-questions-modal__intro">
          <small className="text-muted d-block">Scegli il workflow</small>
          <p className="mb-0">
            Clona una configurazione sorgente quando vuoi che il sistema prepari ed esegua il tagging sulle domande
            generate, oppure collega direttamente un report del Tagging Tool gia pronto.
          </p>
        </div>

        <FormGroup>
          <Label className="form-control-label d-flex align-items-center" htmlFor={`${tooltipPrefix}-report-select`}>
            Report del Tagging Tool
          </Label>
          <Select
            inputId={`${tooltipPrefix}-report-select`}
            options={reportOptions}
            isClearable
            value={selectedOption}
            onChange={(selected) => onSelectedReportChange(selected?.value || '')}
            placeholder="Seleziona un report del Tagging Tool"
          />
        </FormGroup>

        <div className="tag-generated-questions-modal__modes">
          <label className="tag-generated-questions-modal__mode">
            <Input
              checked={mode === MODES.CLONE}
              name={`${tooltipPrefix}-mode`}
              onChange={() => onModeChange(MODES.CLONE)}
              type="radio"
            />
            <div>
              <div className="d-flex align-items-center">
                <span className="font-weight-bold">Clona da un report esistente</span>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id={`${tooltipPrefix}-clone-tooltip`}>
                      Crea una copia del report selezionato, disattiva le dimensioni thanos sul clone, carica le
                      domande generate in un file server-side e avvia il tagging sul clone.
                    </Tooltip>
                  }
                >
                  <button className="tag-generated-questions-modal__help" type="button">
                    ?
                  </button>
                </OverlayTrigger>
              </div>
              <small className="text-muted">
                Ideale quando il report selezionato e solo un modello o una configurazione di partenza.
              </small>
            </div>
          </label>

          <label className="tag-generated-questions-modal__mode">
            <Input
              checked={mode === MODES.CONNECT_EXISTING}
              name={`${tooltipPrefix}-mode`}
              onChange={() => onModeChange(MODES.CONNECT_EXISTING)}
              type="radio"
            />
            <div>
              <div className="d-flex align-items-center">
                <span className="font-weight-bold">Collega un report esistente</span>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id={`${tooltipPrefix}-connect-tooltip`}>
                      Non clona e non importa nulla. Collega soltanto questa esecuzione LLM Visibility a un report del
                      Tagging Tool gia esistente e aggiorna le viste collegate se il report e gia esportato.
                    </Tooltip>
                  }
                >
                  <button className="tag-generated-questions-modal__help" type="button">
                    ?
                  </button>
                </OverlayTrigger>
              </div>
              <small className="text-muted">
                Ideale quando il report di destinazione contiene gia il dataset corretto di domande taggate.
              </small>
            </div>
          </label>
        </div>

      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} type="button">
          Annulla
        </Button>
        <Button color="info" disabled={submitting || !selectedReportId} onClick={onSubmit} type="button">
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" className="mr-2" role="status" aria-hidden="true" />
              Elaborazione...
            </>
          ) : mode === MODES.CLONE ? 'Avvia Tagging' : 'Collega report'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TagGeneratedQuestionsModal
